import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-push-notification',
  templateUrl: './push-notification.component.html',
  styleUrls: ['./push-notification.component.scss'],
})
export class PushNotificationComponent implements OnInit {
  constructor(private route: ActivatedRoute) {}

  selectedIndex = 0;

  public onTabChange() {}

  ngOnInit() {
    this.route.queryParams.subscribe((qp) => {
      this.selectedIndex = qp.tabindex || 0;
    });
  }
}
